<app-navbar></app-navbar>
<section class="premium-3d-list-page py-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div>
                    <div class="premium-page-header mb-5 text-center">
                        <h1 class="ultimate-3d-title">{{ selectedItemName }}</h1>
                        <div class="premium-header-divider mx-auto mt-3"></div>
                    </div>

                    <!-- Governing Body -->
                    <div *ngIf="selectedItem && selectedItem === 'governing-body'">
                        <ng-container *ngIf="GBs == null" class="spinner-overlay">
                            <div class="text-center mt-5"><span class="badge bg-secondary">No Data Found</span></div>
                        </ng-container>

                        <div class="row g-4 justify-content-center" *ngIf="GBs2 != null">
                            <ng-container *ngFor="let item of GBs2">
                                <div class="col-lg-4 col-md-6">
                                    <div class="ultimate-3d-profile-card">
                                        <div class="profile-image-container">
                                            <img [src]="item.ImagePath || 'assets/img/default-teacher.png'"
                                                alt="team" />
                                        </div>
                                        <div class="profile-content">
                                            <h3 class="profile-name">{{ item.Name }}</h3>
                                            <p class="profile-role">{{item.GBDesignation }}</p>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <!-- Teacher Information -->
                    <div *ngIf="selectedItem && selectedItem === 'teacher-information'">
                        <ng-container *ngIf="TeacherInfo == null" class="spinner-overlay">
                            <div class="text-center mt-5"><span class="badge bg-secondary">No Data Found</span></div>
                        </ng-container>

                        <div class="row g-4 justify-content-center" *ngIf="TeacherInfo != null">
                            <ng-container *ngFor="let item of TeacherInfo">
                                <div class="col-lg-4 col-md-6">
                                    <div class="ultimate-3d-profile-card">
                                        <div class="profile-image-container">
                                            <img [src]="item.ImageLink || 'assets/img/default-teacher.png'"
                                                alt="teacher" />
                                        </div>
                                        <div class="profile-content">
                                            <h3 class="profile-name">{{ item.EmployeeName }}</h3>
                                            <p class="profile-role">{{item.Designation }}</p>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <!-- School Teachers -->
                    <div *ngIf="selectedItem && selectedItem == 'teachers-list-school'">
                        <ng-container *ngIf="schoolTeacher == null" class="spinner-overlay">
                            <div class="text-center mt-5"><span class="badge bg-secondary">No Data Found</span></div>
                        </ng-container>

                        <div class="row g-4 justify-content-center" *ngIf="schoolTeacher !== null">
                            <ng-container *ngFor="let item of schoolTeacher">
                                <div class="col-lg-4 col-md-6">
                                    <div class="ultimate-3d-profile-card">
                                        <div class="profile-image-container">
                                            <img [src]="item.ImageLink || 'assets/img/default-teacher.png'"
                                                alt="teacher" />
                                        </div>
                                        <div class="profile-content">
                                            <h3 class="profile-name">{{ item.EmployeeName }}</h3>
                                            <p class="profile-role">{{item.Designation }}</p>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <!-- College Teachers -->
                    <div *ngIf="selectedItem  && selectedItem == 'teachers-list-college'">
                        <ng-container *ngIf="collgeTeacher == null" class="spinner-overlay">
                            <div class="text-center mt-5"><span class="badge bg-secondary">No Data Found</span></div>
                        </ng-container>

                        <div class="row g-4 justify-content-center" *ngIf="collgeTeacher !== null">
                            <ng-container *ngFor="let item of collgeTeacher">
                                <div class="col-lg-4 col-md-6">
                                    <div class="ultimate-3d-profile-card">
                                        <div class="profile-image-container">
                                            <img [src]="item.ImageLink || 'assets/img/default-teacher.png'"
                                                alt="teacher" />
                                        </div>
                                        <div class="profile-content">
                                            <h3 class="profile-name">{{ item.EmployeeName }}</h3>
                                            <p class="profile-role">{{item.Designation }}</p>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    <!-- Fallback Message / Default -->
                    <div
                        *ngIf="selectedItem && selectedItem !== 'governing-body' && selectedItem !== 'teacher-information' && selectedItem !== 'teachers-list-school' && selectedItem !== 'teachers-list-college'">
                        <ng-container *ngIf="GBms == null" class="spinner-overlay">
                            <div class="text-center mt-5"><span class="badge bg-secondary">No Data Found</span></div>
                        </ng-container>

                        <div class="ultimate-3d-card message-card p-5" *ngIf="GBms1">
                            <div class="row align-items-start">
                                <div class="col-md-5 text-center mb-4 mb-md-0 position-relative">
                                    <div class="message-image-wrapper mx-auto">
                                        <img alt="Message" class="img-fluid message-img" [src]="GBms1.GBImagePath" />
                                    </div>
                                </div>
                                <div class="col-md-7 ps-md-4">
                                    <article class="ultimate-text-content message-text">
                                        <div [innerHTML]="GBms1.DetailsEn"></div>
                                    </article>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>